import { useMutation } from "@tanstack/react-query";
import { postApiPracticesPracticeIdPatientsPatientIdCaptureSessions } from "@/lib/api-client/endpoints/capture-sessions/capture-sessions";

export function useInitiateCaptureLink(practiceId: string, patientId: string) {
  const mutation = useMutation({
    mutationFn: async () => {
      const response =
        await postApiPracticesPracticeIdPatientsPatientIdCaptureSessions(
          practiceId,
          patientId,
          { channel: "link" },
        );

      if (!response.data.notificationSent) throw new Error();

      return response.data;
    },
  });

  return {
    initiate: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error,
  };
}
